import * as React from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../Context';
import { IRootState } from '../../definitions/root';
import Brand from './components/Brand';

export default function HeaderRender({ menu }) {
  const { location: { pathname } } = this.props;

  return (
    <AppContext.Consumer>
      {({ app: { isMobile, isTablet } }: IRootState) => {
        if (!menu) {
          return null;
        }

        const links = menu.map(({ link, name }) => {
          const isActive = pathname === `/${link}`;
          return (
            <Link
              to={{ pathname: `${['Careers'].includes(name) ? link : '/' + link}` }}
              key={`link-${link}`}
              className={isActive ? 'active' : ''}
              onClick={isMobile || isTablet ? this.toggleMobMenu : undefined}
              target={['Careers'].includes(name) ? '_blank' : ''}>
              <span>{name}</span>
            </Link>
          );
        });

        return (
          <header className="main-header">
            <div className="container">
              <div className="row middle-lg">
                <div className="head col-xs-12 col-lg-2">
                  <div className="row middle-xs">
                    <Brand logo={this.brandLogo} />

                    <div className="menu-toggle-container col-xs-6 end-xs">
                      <div className="menu-toggle" onClick={this.toggleMobMenu}>
                        <div className="icon">
                          <span className="line" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <nav className="main-nav col-lg-10">
                  <div className="menu end-lg">
                    {links && links.length > 0 && links}
                  </div>
                </nav>
              </div>
            </div>
          </header>
        );
      }}
    </AppContext.Consumer>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Header/render.tsx